import { Card, Icon, Tag } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import React from 'react'
import Channels, { channelById } from '../../../constants/Channels'
import ChannelIcon from '../../ChannelIcon'
import ExternalChannelLink from '../../ExternalChannelLink'
import InteractiveDatetime from '../../InteractiveDatetime'
import NiceListingStatus from '../../NiceListingStatus'

const ProductListings = ({ productListings, currentListingId, channelId, onCardClick }) => {
  const channel = channelById(channelId)
  const getListingId = pl => (['etsy', 'amazon', 'depop'].includes(channel.name) ? pl.listingId : pl.id)
  return (
    <div className="listing-details inverted">
      <div className="drawer-header">
        <Icon icon={IconNames.PROPERTY} /> Listings
        <Tag minimal round>
          {productListings.length}
        </Tag>
      </div>
      {productListings
        .sort((a, b) => b.relistCount - a.relistCount)
        .map(pl => (
          <Card
            className="product-listing-card"
            data-testid={`product-listing-card-${pl.id}`}
            interactive={currentListingId !== pl.id}
            key={pl.id}
            onClick={e => {
              if ((e.target as HTMLAnchorElement).href || pl.id === currentListingId) return
              onCardClick(pl.id)
            }}
            style={{
              marginBottom: 10,
              display: 'flex',
              alignItems: 'center',
              cursor: getListingId(pl) !== currentListingId ? 'pointer' : undefined,
              border: getListingId(pl) === currentListingId ? `1px solid #137CBD` : undefined
            }}
          >
            <div style={{ maxWidth: 50, marginRight: 10 }}>
              <ChannelIcon channelId={channelId} />
            </div>
            <div>
              <h3 style={{ margin: '0 0 5px 0' }}>
                {channelId === Channels.SHOPIFY.id
                  ? `${channel.humanReadableName} - ${pl.shopifyAccountName}`
                  : channel.humanReadableName}
              </h3>
              <ExternalChannelLink channel={channel.name} id={pl.externalMarketId} listingUrl={pl.listingUrl} />
            </div>
            <div style={{ marginLeft: '20px' }}>
              {pl.startTime && (
                <div style={{ marginBottom: 5 }}>
                  <span style={{ color: '#9ca0a7' }}>Started:</span> <InteractiveDatetime value={pl.startTime} />
                </div>
              )}
              {pl.endTime && (
                <div>
                  <span style={{ color: '#9ca0a7' }}>Ended:</span> <InteractiveDatetime value={pl.endTime} />
                </div>
              )}
            </div>

            <div style={{ marginLeft: 'auto' }}>
              <NiceListingStatus value={pl.state} large />
            </div>
          </Card>
        ))}
    </div>
  )
}
export default ProductListings
